<template>
    <div class="nevs-content">
        <ModalPayment :show="showPaymentModal" :invoice-id="null" :payment="editingPayment" @done="paymentModalDone"></ModalPayment>
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsButton class="primary help-multiple-payments" @click="multiplePaymentsClick">
                <i class="fa-solid fa-credit-card"></i>
                {{ $LANG.Get('buttons.multiplePayments') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsSelect :nullable="true" v-model="tableData.filters.invoice_id" :ajax="'select/invoices'"
                            :label="$LANG.Get('fields.invoice')"
                            @select="filterLabels.invoice_id = $event.label"></NevsSelect>
                <NevsSelect :nullable="true" v-model="tableData.filters.customer_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.customer')"
                            @select="filterLabels.customer_id = $event.label"></NevsSelect>
                <NevsDateField v-model="tableData.filters.date_from"
                               :label="$LANG.Get('fields.date_from')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_to"
                               :label="$LANG.Get('fields.date_to')"></NevsDateField>
                <NevsSelect :nullable="true" v-model="tableData.filters.payment_method_id" :ajax="'select/payment-methods'"
                            :label="$LANG.Get('fields.paymentMethod')"
                            @select="filterLabels.payment_method_id = $event.label"></NevsSelect>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <div v-if="tableData.hasDisclaimers" ref="disclaimerAlert" class="payment-disclaimer-alert">
                {{ $LANG.Get('labels.somePaymentsHaveDisclaimers') }}
                <NevsCheckbox v-model="tableData.filters.disclaimer"
                              :label="$LANG.Get('labels.onlyPaymentsWithDisclaimers')"></NevsCheckbox>
            </div>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-cell help-edit">
                        <NevsButton v-if="item.disclaimer != ''" @click.stop="showDisclaimer(item.disclaimer)" :title="item.disclaimer" class="error invoice-disclaimer-button"><i class="fa-solid fa-triangle-exclamation"></i></NevsButton>
                        {{ item.date_display }}
                        <span class="e-status-pill" v-if="item.reported">EI</span>
                    </td>
                    <td class="nevs-table-cell">{{ item.invoice_display }}</td>
                    <td class="nevs-table-cell">{{ item.invoice_date_of_issue_display }}</td>
                    <td class="nevs-table-cell">{{ item.customer_display }}</td>
                    <td class="nevs-table-cell">{{ item.payment_method_display }}</td>
                    <td class="nevs-table-cell">{{ item.amount_display }}</td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'200px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import ModalPayment from "@/components/modals/ModalPayment.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";

export default {
    name: "ModulePayments",
    components: {NevsTableFilters, ModalPayment, NevsCheckbox, NevsDateField, NevsActions, NevsSelect, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'date',
                        label: this.$LANG.Get('fields.paymentDate')
                    },
                    {
                        name: 'invoice',
                        label: this.$LANG.Get('fields.invoice'),
                        sortable: false
                    },
                    {
                        name: 'invoice_time_of_issue',
                        label: this.$LANG.Get('fields.invoiceDateOfIssue')
                    },
                    {
                        name: 'customer',
                        label: this.$LANG.Get('fields.customer'),
                        sortable: false
                    },
                    {
                        name: 'payment_method',
                        label: this.$LANG.Get('fields.paymentMethod')
                    },
                    {
                        name: 'amount',
                        label: this.$LANG.Get('fields.paymentAmount')
                    },
                    {
                        name: 'actions',
                        width: '200px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    invoice_id: null,
                    customer_id: null,
                    date_from: null,
                    date_to: null,
                    payment_method_id: null,
                    disclaimer: false
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                hasDisclaimers: false,
                defaultSort: {
                    field: 'date',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.edit'),
                    action: (item) => {
                        this.editClick(item);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.eReporting'),
                    action: (item) => {
                        this.eReportingClick(item);
                    },
                    visible: (item) => {
                        return item.disclaimer !== '';
                    }
                },
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only carries the
            // id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                invoice_id: '',
                customer_id: '',
                payment_method_id: ''
            },
            crossTabHandle: null,
            showPaymentModal: false,
            editingPayment: null
        }
    },
    watch: {
        'tableData.filters.disclaimer'(value) {
            //the disclaimer filter is exclusive, so ticking it clears everything else
            if (value) {
                this.resetFilters();
            }
        },
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        },
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed here and
        // the panel picks the active ones. The disclaimer filter is left out: it lives in the alert above the
        // table, not in the panel.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'invoice_id',
                    label: this.$LANG.Get('fields.invoice'),
                    value: filters.invoice_id === null ? '' : this.filterLabels.invoice_id
                },
                {
                    name: 'customer_id',
                    label: this.$LANG.Get('fields.customer'),
                    value: filters.customer_id === null ? '' : this.filterLabels.customer_id
                },
                {
                    name: 'date_from',
                    label: this.$LANG.Get('fields.date_from'),
                    value: filters.date_from === null ? '' : this.$HELPERS.FormatDate(filters.date_from)
                },
                {
                    name: 'date_to',
                    label: this.$LANG.Get('fields.date_to'),
                    value: filters.date_to === null ? '' : this.$HELPERS.FormatDate(filters.date_to)
                },
                {
                    name: 'payment_method_id',
                    label: this.$LANG.Get('fields.paymentMethod'),
                    value: filters.payment_method_id === null ? '' : this.filterLabels.payment_method_id
                }
            ];
        }
    },
    methods: {
        multiplePaymentsClick() {
            this.$router.push('/multiple-payments');
        },
        eReportingClick(payment) {
            let vm = this;
            vm.$API.APICall('post', 'payments/e-reporting/' + payment.id, {}, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.eReportingPaymentSuccess'), type: 'alert'});
                    vm.reloadTable(vm.tableData.lastRequest);
                } else {
                    if (data.message === 'e-reporting failed') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.eReportingPaymentFailed'), type: 'alert'});
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }
            });
        },
        showDisclaimer(disclaimer) {
            this.$LOCAL_BUS.TriggerEvent('popup', {
                text: disclaimer,
                type: 'alert'
            });
        },
        deleteClick(payment) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.paymentDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'payments/' + payment.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-payments', {});
                            } else {
                                if (data.message === 'e-reporting failed') {
                                    vm.$LOCAL_BUS.TriggerEvent('popup', {
                                        text: vm.$LANG.Get('alerts.eReportingPaymentFailed'),
                                        type: 'alert'
                                    });
                                } else {
                                    vm.$HELPERS.HandleServerError(vm, data);
                                }
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                invoice_id: null,
                customer_id: null,
                date_from: null,
                date_to: null,
                payment_method_id: null
            };
        },
        //the disclaimer filter lives in the alert above the table, not in the filter panel, so it is kept as it is
        resetFilters() {
            this.tableData.filters = Object.assign(this.emptyFilters(), {
                disclaimer: this.tableData.filters.disclaimer
            });
            for (let key in this.filterLabels) {
                this.filterLabels[key] = '';
            }
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.resolveWindowResize();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'payments/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.sererError'), type: 'alert'});
                }
            });
        },
        paymentModalDone(success) {
            this.showPaymentModal = false;
            if (success) {
                this.reloadTable(this.tableData.lastRequest);
            }
        },
        addClick() {
            this.editingPayment = null;
            this.showPaymentModal = true;
        },
        editClick(item) {
            this.editingPayment = item;
            this.showPaymentModal = true;
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'payments', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                    vm.tableData.hasDisclaimers = data.has_disclaimers;
                    vm.$nextTick(() => {
                        vm.resolveWindowResize();
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            let offset = 205;
            //the alert grew a checkbox, so its height is measured instead of hardcoded (5 is its bottom margin)
            if (this.tableData.hasDisclaimers && this.$refs.disclaimerAlert) {
                offset += this.$refs.disclaimerAlert.offsetHeight + 5;
            }
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-multiple-payments',
                html: this.$LANG.Get('help.multiplePayments'),
                left: 100,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'payments');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.payments'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-payments', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}

.payment-disclaimer-alert {
    background: $banner-warning;
    padding: 10px;
    color: black;
    // No horizontal margin: the table below it sits flush against the card's padding, so anything here would
    // leave the alert visibly narrower than the grid it belongs to.
    margin: 0 0 5px;
    border-radius: 5px;
}

.payment-disclaimer-alert :deep(.nevs-field) {
    margin-top: 5px;
    width: auto;
}

.e-status-pill {
    text-align: center;
    display: inline-block;
    background-color: $primary-hover;
    padding: 5px;
    border-radius: 5px;
}
</style>